// import { defaultLocale, localeOptions } from '../../constants/defaultValues'

import {
	LOGOUT_USER,

	// Staff Management
	SETTING_LOAD_DEPARTMENT,
	SETTING_LOAD_DEPARTMENT_SUCCESS,
	SETTING_CREATE_DEPARTMENT,
	SETTING_UPDATE_DEPARTMENT,
	SETTING_DELETE_DEPARTMENT,

	SETTING_LOAD_POSITION,
	SETTING_LOAD_POSITION_SUCCESS,
	SETTING_CREATE_POSITION,
	SETTING_UPDATE_POSITION,
	SETTING_DELETE_POSITION,

	SETTING_LOAD_STAFF,
	SETTING_LOAD_STAFF_SUCCESS,
	SETTING_CREATE_STAFF,
	SETTING_UPDATE_STAFF,
	SETTING_DELETE_STAFF,
	// END Staff Management


} from '../../actions';

const INIT_STATE = {

	department: [],
	optionDepartment: [],

	position: [],
	optionPosition: [],

	staff: [],
	optionStaff: [],

	departmentLoading: false,
	positionLoading: false,
	staffLoading: false,

};

export default (state = INIT_STATE, action) => {
	switch (action.type) {

		case SETTING_LOAD_DEPARTMENT:
			return { ...state, departmentLoading: true }
		case SETTING_LOAD_DEPARTMENT_SUCCESS:
			return {
				...state,
				departmentLoading: false,
				department: action.payload,
				optionDepartment: action.payloadlist
			}
		case SETTING_CREATE_DEPARTMENT:
			return { ...state, departmentLoading: true }
		case SETTING_UPDATE_DEPARTMENT:
			return { ...state, departmentLoading: true }
		case SETTING_DELETE_DEPARTMENT:
			return { ...state, departmentLoading: true }

		case SETTING_LOAD_POSITION:
			return { ...state, positionLoading: true }
		case SETTING_LOAD_POSITION_SUCCESS:
			return {
				...state,
				positionLoading: false,
				position: action.payload,
				optionPosition: action.payloadlist
			}
		case SETTING_CREATE_POSITION:
			return { ...state, positionLoading: true }
		case SETTING_UPDATE_POSITION:
			return { ...state, positionLoading: true }
		case SETTING_DELETE_POSITION:
			return { ...state, positionLoading: true }

		case SETTING_LOAD_STAFF:
			return { ...state, staffLoading: true }
		case SETTING_LOAD_STAFF_SUCCESS:
			return {
				...state,
				staffLoading: false,
				staff: action.payload,
				optionStaff: action.payloadlist
			}
		case SETTING_CREATE_STAFF:
			return { ...state, staffLoading: true }
		case SETTING_UPDATE_STAFF:
			return { ...state, staffLoading: true }
		case SETTING_DELETE_STAFF:
			return { ...state, staffLoading: true }

		case LOGOUT_USER:
			return {
				...state,
				department: [],
				optionDepartment: [],

				position: [],
				optionPosition: [],

				staff: [],
				optionStaff: [],

				departmentLoading: false,
				positionLoading: false,
				staffLoading: false,
			};

		default: return { ...state };
	}
}